import { Delivery } from '../../api/models/deliveries';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RadioChangeEvent } from 'antd/es/radio';
import { Badge, Col, Radio, Typography } from 'antd';
import styles from './SearchResults.module.less';
import DetailedDeliveryCard from '../../components/DetailedDeliveryCard/DetailedDeliveryCard';
import PastDeliveryCard from '../../components/PastDeliveryCard/PastDeliveryCard';
import { DeliveriesTracking } from '../../api/models/deliveriesTracking';
import LoadMoreButton from '../../components/Button/LoadMoreButton';

const ACTIVE = 'active';
const PAST = 'past';

export type SearchResultType = {
  activeDeliveries: Delivery[];
  pastDeliveries: Delivery[];
  isActiveDeliveriesLoading: boolean;
  isPastDeliveriesLoading: boolean;
  loadMorePastDeliveries?: (...args: any[]) => Promise<any>;
  trackingData?: DeliveriesTracking;
  hasMore?: boolean;
  showNotFound?: boolean;
  searchText: string;
};
export const SearchResult = (props: SearchResultType) => {
  const {
    activeDeliveries,
    pastDeliveries,
    loadMorePastDeliveries,
    hasMore,
    isPastDeliveriesLoading,
    trackingData,
    showNotFound,
    searchText
  } = props;
  const [mode, setMode] = useState(ACTIVE);
  const { t } = useTranslation();
  const onGroupChange = useCallback((event: RadioChangeEvent) => {
    setMode(event.target.value);
  }, []);
  const [expandedCard, setExpandedCard] = useState<string>();
  return (
    <>
      <div className={styles.radioGroupContainer}>
        <Radio.Group onChange={onGroupChange} value={mode}>
          <Radio.Button value={ACTIVE} className={styles.radioButton}>
            <div className={styles.radioButtonContent}>
              <div className={styles.radioButtonTitle}>{t('search.activeDeliveries')}</div>
              <div>
                <Badge count={activeDeliveries.length} showZero />
              </div>
            </div>
          </Radio.Button>
          <Radio.Button value={PAST} className={styles.radioButton}>
            <div className={styles.radioButtonContent}>
              <div className={styles.radioButtonTitle}>{t('search.pastDeliveries')}</div>
              <div>
                <Badge count={pastDeliveries.length} showZero />
              </div>
            </div>
          </Radio.Button>
        </Radio.Group>
      </div>
      {showNotFound ? (
        <div className={styles.notFoundContainer}>
          <Typography.Text strong>{t('search.notFound', { searchText: searchText })}</Typography.Text>
        </div>
      ) : (
        <div className={styles.resultContainer}>
          {mode === ACTIVE ? (
            <div className={styles.deliveryCardsContainer}>
              {activeDeliveries?.map(delivery => (
                <DetailedDeliveryCard
                  key={delivery.id}
                  {...delivery}
                  handleExpandClick={setExpandedCard}
                  trackingData={trackingData?.[delivery.id]}
                  isExpanded={expandedCard === delivery.id.toString()}
                />
              ))}
            </div>
          ) : (
            <div className={styles.deliveryCardsContainer}>
              {pastDeliveries?.map(delivery => (
                <PastDeliveryCard
                  key={delivery.id}
                  {...delivery}
                  handleExpandClick={setExpandedCard}
                  isExpanded={expandedCard === delivery.id.toString()}
                />
              ))}
              {hasMore && (
                <Col className={styles.loadMoreContainer}>
                  <LoadMoreButton onClick={loadMorePastDeliveries} loading={isPastDeliveriesLoading} />
                </Col>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};
